import GroupCardHeader from './GroupCardHeader';

export default GroupCardHeader;
